import { Checkbox, Dropdown, Menu } from 'antd';
import { IMilestoneCategory, IMilestoneData } from '../api/getMilestone';
import { editIcon, moreIcon, tickIcon2 } from './common/Icons';
import { IMilestoneHistory, IMilestoneStatus } from './common/types/milestones';
import {
    acheivedOptions,
    allMilestoneOptions,
    mileStoneCategoryName,
    mileStonesoptions,
    milestoneCardConfig,
    milestoneDeleteOptions,
} from './common/constants/milestones';
import { useDispatch } from 'react-redux';
import {
    openMilestonConfimationDialog,
    deleteMilestonConfimationDialog,
} from './common/milestoneModals';

export const MileStoneCard: React.FC<{
    milestoneData: IMilestoneData;
    index: number;
    selectedMilestones: IMilestoneData[];
    setSelectedMilestones: (
        val: IMilestoneData,
    ) => {
        add: () => void;
        delete: () => void;
        toggle: () => void;
    };
    status: IMilestoneStatus | undefined;
    saveMileStone: (status: IMilestoneHistory) => void;
    age:
        | {
              value: string;
              unit?: string;
          }
        | undefined;
    openModalForEdit: (milestoneData: IMilestoneData) => void;
    markPreviousMilestonesAsAchieved: (
        status: IMilestoneStatus,
        categoryId: IMilestoneCategory,
        ageGroup?: string,
        markprev?: boolean,
    ) => void;
    categoryMap: Record<string, boolean>;
    deleteMilestoneCallback: (milestone: IMilestoneData) => Promise<void>;
    clearMilestonesCallback: (clearedMilestones?: IMilestoneHistory[], isReset?: boolean) => void;
    ageGrpIdx: number;
    getMilestoneSummary: (
        milestonesTillCurrAge: IMilestoneData[],
        markedMilestonesAll: IMilestoneHistory[],
    ) => {
        statuses: IMilestoneHistory[];
        result?: any;
    };
    getAllPrevMilestones: (
        categoryId?: IMilestoneCategory,
        ageGroup?: string,
        markprev?: boolean,
    ) => IMilestoneData[] | undefined;
    markedMilestones: IMilestoneHistory[];
}> = ({
    milestoneData,
    index,
    setSelectedMilestones,
    selectedMilestones,
    status,
    saveMileStone,
    age,
    openModalForEdit,
    markPreviousMilestonesAsAchieved,
    categoryMap,
    deleteMilestoneCallback,
    clearMilestonesCallback,
    ageGrpIdx,
    getAllPrevMilestones,
    getMilestoneSummary,
    markedMilestones,
}) => {
    const { name, categoryId, id } = milestoneData;

    const isSelected = selectedMilestones.find((m) => m.id === milestoneData.id);

    const enteredAge = markedMilestones.find((m) => m.id === id)?.age;
    const ageValue = enteredAge ?? age;

    const isMarked = status && milestoneCardConfig[status];

    const currstate = allMilestoneOptions.find((v) => v.status === status);

    const dispatch = useDispatch();

    const markAchieved = (status?: IMilestoneStatus) => {
        saveMileStone({
            id: milestoneData.id,
            status: status as IMilestoneStatus,
            age:
                status !== 'achieved' && status !== 'under_observation' && status !== 'delayed'
                    ? undefined
                    : age,
            categoryId: milestoneData.categoryId,
            name: milestoneData.name,
            category: milestoneData.category,
        });

        const data = getAllPrevMilestones(undefined, milestoneData.ageGroup, false);

        const summary = data ? getMilestoneSummary(data, markedMilestones) : undefined;

        if (
            categoryMap &&
            categoryMap[milestoneData.categoryId] !== undefined &&
            categoryMap[milestoneData.categoryId] === false &&
            ageGrpIdx !== 0 &&
            summary?.result?.[milestoneData.categoryId]?.achieved !== true
        ) {
            dispatch(
                openMilestonConfimationDialog(
                    () =>
                        markPreviousMilestonesAsAchieved(
                            'achieved_unknown' as IMilestoneStatus,
                            milestoneData.categoryId,
                            milestoneData.ageGroup,
                            true,
                        ),
                    undefined,
                    [milestoneData.categoryId],
                ),
            );
        }
    };

    return (
        <div
            className={`flex w-full cursor-pointer flex-col justify-between rounded-8 ${
                isMarked
                    ? `${milestoneCardConfig[status!].bg} ${
                          milestoneCardConfig[status!].border
                      } border`
                    : 'bg-white'
            } ${isSelected && !isMarked ? 'border border-darwin-accent-bright-blue-800' : ''}`}
        >
            <div
                id={id}
                className={`flex ${
                    isMarked
                        ? 'pb-12'
                        : isSelected
                        ? 'pb-16'
                        : 'pb-16 hover:bg-darwin-accent-bright-blue-100'
                } milestone-card-${index} px-16 pt-12 justify-between items-center`}
                onClick={
                    selectedMilestones.length
                        ? () => setSelectedMilestones(milestoneData).toggle()
                        : () => openModalForEdit(milestoneData)
                }
            >
                <div className="flex flex-col self-start gap-4">
                    <p className="font-700 text-14 max-w-240">{name}</p>
                    <p className="font-400 text-13">{mileStoneCategoryName[categoryId]}</p>
                </div>
                <Checkbox
                    className={`${
                        isSelected
                            ? ''
                            : selectedMilestones.length === 0
                            ? `milestone-card-child-element-${index}`
                            : ''
                    } milestone-card-checkbox self-start`}
                    onClick={(e) => e.stopPropagation()}
                    checked={isSelected ? true : false}
                    onChange={(e) => {
                        if (e.target.checked) {
                            setSelectedMilestones(milestoneData).add();
                        } else {
                            setSelectedMilestones(milestoneData).delete();
                        }
                    }}
                />
            </div>
            {isMarked ? (
                <div
                    onClick={
                        selectedMilestones.length
                            ? () => setSelectedMilestones(milestoneData).toggle()
                            : () => openModalForEdit(milestoneData)
                    }
                    className="flex pl-12 pb-8 pr-8 justify-between items-center"
                >
                    <div className="flex items-center gap-4">
                        <span className="p-4">{currstate?.icon}</span>
                        <p className="text-13">
                            {currstate?.title}
                            {ageValue?.value
                                ? status !== 'achieved' &&
                                  status !== 'achieved_unknown' &&
                                  status !== 'under_observation' &&
                                  status !== 'delayed'
                                    ? ` at ${ageValue?.value}${
                                          ageValue?.unit ? ageValue.unit.slice(0, 1) : ''
                                      }`
                                    : ''
                                : null}
                        </p>
                    </div>

                    <div className={`flex items-center gap-8 ${isSelected ? 'invisible' : ''}`}>
                        <span
                            onClick={() => openModalForEdit(milestoneData)}
                            className="p-10 rounded-8 hover:bg-darwin-neutral_new-50 cursor-pointer"
                        >
                            {editIcon('w-14 h-14')}
                        </span>
                        <MoreOptions
                            saveMileStone={saveMileStone}
                            milestoneData={milestoneData}
                            age={age}
                            hideText
                            className="flex rounded-8 hover:bg-darwin-neutral_new-50 flex-shrink-0 cursor-pointer justify-center px-14 py-10 gap-8 items-center font-700"
                            deleteMilestoneCallback={deleteMilestoneCallback}
                            openModalForEdit={openModalForEdit}
                            clearMilestonesCallback={clearMilestonesCallback}
                        />
                    </div>
                </div>
            ) : (
                <div
                    className={`flex bg-white rounded-b-8 justify-between ${
                        isSelected ? '' : 'border-t border-darwin-neutral_new-200'
                    }`}
                    onClick={
                        selectedMilestones.length
                            ? () => setSelectedMilestones(milestoneData).toggle()
                            : undefined
                    }
                >
                    <Dropdown
                        trigger={['hover']}
                        destroyPopupOnHide
                        placement="bottomLeft"
                        overlay={
                            <Menu className="rounded-4 bg-white">
                                {acheivedOptions.map((opt) => (
                                    <Menu.Item onClick={() => markAchieved(opt.status)}>
                                        <div className="flex px-8 py-4 items-center gap-8">
                                            <span>{opt.icon}</span>
                                            <p className="text-14 font-400">{opt.title}</p>
                                        </div>
                                    </Menu.Item>
                                ))}
                            </Menu>
                        }
                        className={isSelected ? 'invisible' : ''}
                    >
                        <div
                            onClick={() => markAchieved('achieved')}
                            className="flex rounded-bl-8 flex-grow cursor-pointer bg-white hover:bg-darwin-accent-bright-blue-100 justify-center px-12 py-10 gap-8 items-center text-darwin-accent-bright-blue-800 font-700"
                        >
                            <span className="border border-darwin-accent-bright-blue-800 flex items-center justify-center rounded-full">
                                {tickIcon2('fill-darwin-accent-bright-blue-800 font-700 w-12 h-12')}
                            </span>
                            <p className="text-13">Mark Achieved</p>
                        </div>
                    </Dropdown>
                    <MoreOptions
                        saveMileStone={saveMileStone}
                        milestoneData={milestoneData}
                        age={age}
                        deleteMilestoneCallback={deleteMilestoneCallback}
                        openModalForEdit={openModalForEdit}
                        className={`flex rounded-br-8 border-l border-darwin-neutral_new-200 relative flex-shrink-0 cursor-pointer hover:bg-darwin-accent-bright-blue-100 justify-center px-14 py-10 gap-8 items-center font-700 ${
                            isSelected ? 'invisible' : ''
                        }`}
                    />
                </div>
            )}

            <style>
                {`
                    .milestone-card-child-element-${index} {
                        display: none;
                    }
    
                    .milestone-card-${index}:hover .milestone-card-child-element-${index} {
                        display: flex;
                    }

                    .milestone-card-${index} {
                        .ant-checkbox-inner {
                            border: 1.5px solid #484848;
                            border-radius: 2px;
                        }

                        .ant-checkbox-checked {
                            .ant-checkbox-inner {
                                border: none;
                            }
                        }
                    }
                `}
            </style>
        </div>
    );
};

const MoreOptions: React.FC<{
    className?: string;
    hideText?: boolean;
    saveMileStone: (status: IMilestoneHistory) => void;
    milestoneData: IMilestoneData;
    age?: { unit?: string; value: string };
    deleteMilestoneCallback: (milestone: IMilestoneData) => Promise<void>;
    openModalForEdit: (milestoneData: IMilestoneData) => void;
    clearMilestonesCallback?: (clearedMilestones?: IMilestoneHistory[], isReset?: boolean) => void;
}> = ({
    className,
    hideText,
    saveMileStone,
    milestoneData,
    age,
    deleteMilestoneCallback,
    openModalForEdit,
    clearMilestonesCallback,
}) => {
    const dispatch = useDispatch();

    const deleteoptions = clearMilestonesCallback
        ? milestoneDeleteOptions
        : milestoneDeleteOptions.filter((m) => m.status !== 'reset');

    const options = [...mileStonesoptions, ...deleteoptions];

    return (
        <Dropdown
            trigger={['click']}
            destroyPopupOnHide
            placement="bottomRight"
            overlay={
                <Menu className="rounded-4 bg-white">
                    {options.map((o) => (
                        <Menu.Item
                            onClick={(val) => {
                                val.domEvent.stopPropagation();

                                if (o.status === 'delayed' || o.status === 'under_observation') {
                                    saveMileStone({
                                        id: milestoneData.id,
                                        status: o.status,
                                        age: undefined,
                                        categoryId: milestoneData.categoryId,
                                        name: milestoneData.name,
                                        category: milestoneData.category,
                                    });
                                } else if (o.status === 'delete') {
                                    dispatch(
                                        deleteMilestonConfimationDialog(
                                            milestoneData.name,
                                            milestoneData.ageGroup,
                                            () => deleteMilestoneCallback(milestoneData),
                                        ),
                                    );
                                } else if (o.status === 'add_notes') {
                                    openModalForEdit(milestoneData);
                                } else if (o.status === 'reset') {
                                    clearMilestonesCallback &&
                                        clearMilestonesCallback(
                                            [
                                                {
                                                    age: undefined,
                                                    notes: undefined,
                                                    status: undefined,
                                                    id: milestoneData.id,
                                                    categoryId: milestoneData.categoryId,
                                                    name: milestoneData.name,
                                                    category: milestoneData.category,
                                                },
                                            ],
                                            true,
                                        );
                                }
                            }}
                        >
                            <div className="flex px-8 py-4 items-center gap-8">
                                <span>{o.icon}</span>
                                <p className="text-14 font-400">{o.optionTitle}</p>
                            </div>
                        </Menu.Item>
                    ))}
                </Menu>
            }
        >
            <div
                style={{ top: 0.7 }}
                className={
                    className ??
                    'flex rounded-br-8 border-l border-darwin-neutral_new-200 relative flex-shrink-0 cursor-pointer hover:bg-darwin-accent-bright-blue-100 justify-center px-14 py-10 gap-8 items-center font-700'
                }
                onClick={(e) => e.stopPropagation()}
            >
                {!hideText && <p className="text-13">More</p>}
                <span>{moreIcon('w-4 h-12')}</span>
            </div>
        </Dropdown>
    );
};
